import { themeGet } from 'styled-system';
import styled from '@emotion/styled';
import React, { Fragment } from 'react';
import { Box, Text, Flex, Heading } from 'roo-ui/components';
import { QH_TERMS_AND_CONDITIONS_URL } from 'config';

const BaseText = styled(Text)`
  font-size: ${themeGet('fontSizes.base')};
`;

const ImportantInformationFooter = () => (
  <Fragment>
    <Flex flexDirection="column" data-print-style="section">
      <Heading.h2 data-print-style="h2" data-testid="important-information-title">
        Important Information{' '}
      </Heading.h2>
      <BaseText mb={4}>This is not a tax invoice. Please find your tax invoice attached to your confirmation email.</BaseText>

      <BaseText>
        Qantas Hotels is not itself a tour, event, activity, car rental or accommodation provider. Goods and services are not provided by
        Qantas Hotels but are provided by other service providers as set out in your booking. Qantas Hotels is acting as agent for the
        service provider and your agreement is made with that other service provider and not with Qantas Hotels. You should obtain and read
        the applicable service provider’s terms and conditions as they may limit or exclude liability in respect of death, personal injury
        and loss or damage to your property. In some cases, where you are booking a stay at a hotel outside of Australia, Qantas Hotels uses
        a third party intermediary, or additional agent, to facilitate your booking with the service provider. Your booking may reference
        this third party as the booking agent.
      </BaseText>
    </Flex>

    <Flex flexDirection="column" data-print-style="section">
      <BaseText fontWeight="bold">Use of Qantas Points</BaseText>

      <BaseText>
        If a Member has redeemed Qantas Points for all or part of a booking and is eligible for a refund in relation to that booking, the
        Member can elect whether they receive that refund (less any applicable fee) in cash, Points, or a combination of cash and Points.
        However, the number of Points or the cash amount refunded in such circumstances cannot exceed the number of Points originally used
        or the cash amount originally paid in respect of the booking.
      </BaseText>
    </Flex>

    <Flex flexDirection="column" data-print-style="section">
      <BaseText fontWeight="bold">Use of Voucher</BaseText>

      <BaseText>
        If you used a voucher for part or full payment of this booking, the amount paid for by the voucher is non-refundable and no
        replacement voucher will be issued when cancelling a booking. Any hotel change or cancellation fees amount will be deducted from the
        amount paid by you, up to a maximum of the amount originally paid by you. Any hotel change or cancellation fees value cannot be paid
        using the voucher value.
      </BaseText>
    </Flex>

    <Flex flexDirection="column" data-print-style="section">
      <BaseText mt={4}>
        † includes fees payable in local currency directly to the hotel. Prices in AUD are approximated and based on the exchange rate at
        time of booking.
      </BaseText>
      <Box mt={4}>
        <BaseText>View terms and conditions at</BaseText>
        <BaseText data-testid="T&C-url" fontWeight="bold">
          &nbsp;&nbsp;{QH_TERMS_AND_CONDITIONS_URL}
        </BaseText>
      </Box>
    </Flex>
  </Fragment>
);

ImportantInformationFooter.displayName = 'ImportantInformationFooter';

export default ImportantInformationFooter;
